
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active" @close="borrar" width="800px">
        <template #header>
          <h4 class="not-margin">
            Crear registro
          </h4>
        </template>

        <div class="con-form">
            <vs-row>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución
                        </label>
                        <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <template v-if="instituciones.length" autocomplete="off">
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="cicloEscolar" class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                Requerido
                            </template>
                            <template v-if="ciclosEscolares.length" autocomplete="off">
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                        <div v-if="cicloEscolar != ''" @click="cicloEscolar = ''" class="tache">
                            <i class="far fa-times-circle"></i>
                        </div>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="programa" class="labelInput">
                            Programa
                        </label>
                        <vs-select filter :loading="loadingPrograma" class="aqui pt-0" id="programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="!programas.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('programa')">
                                Requerido
                            </template>
                            <template v-if="programas.length" autocomplete="off">
                                <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="periodo" class="labelInput">
                            Nivel académico
                        </label>
                        <vs-select filter :loading="loadingPeriodo" class="aqui pt-0" id="periodo" placeholder="Seleccionar Nivel académico" :key="periodoId" v-model="periodo" :disabled="!periodos.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('periodo')">
                                Requerido
                            </template>
                            <template v-if="periodos.length" autocomplete="off">
                                <vs-option v-for="option in periodos" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="turno" class="labelInput">
                            Turno
                        </label>
                        <vs-select :loading="loadingTurno" filter class="aqui pt-0" id="turno" placeholder="Seleccionar Turno" :key="turnoId" v-model="turno" :disabled="!turnos.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('turno')">
                                Requerido
                            </template>
                            <template v-if="turnos.length" autocomplete="off">
                                <vs-option v-for="option in turnos" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="nombre" class="labelInput">
                            Nombre
                        </label>
                        <vs-input class="pt-0" id="nombre" v-model="nombre" placeholder="Nombre">
                            <template #message-danger v-if="errorFields.includes('nombre')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="fecha-inicio" class="labelInput">
                            Inicio
                        </label>
                        <vs-input
                            class="pt-0" 
                            type="date"
                            v-model="fecha_inicio"
                        >
                            <template #message-danger v-if="errorFields.includes('fecha_inicio')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="fecha-fin" class="labelInput">
                            Fin
                        </label>
                        <vs-input
                            class="pt-0" 
                            type="date"
                            v-model="fecha_fin"
                            :min='fecha_inicio'
                        >
                            <template #message-danger v-if="errorFields.includes('fecha_fin')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="meta" class="labelInput">
                            Meta
                        </label>
                        <vs-input class="pt-0"  type="number" id="meta" v-model="meta" placeholder="Meta">
                            <template #message-danger v-if="errorFields.includes('meta')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="capacidad" class="labelInput">
                            Capacidad
                        </label>
                        <vs-input class="pt-0"  type="number" id="capacidad" v-model="capacidad" placeholder="Capacidad">
                            <template #message-danger v-if="errorFields.includes('capacidad')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <!-- <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="tope_acumulado" class="labelInput">
                            Tope acumulado de becas
                        </label>
                        <vs-input class="pt-0"  type="number" id="tope_acumulado" v-model="tope_acumulado" placeholder="Tope acumulado de becas">
                            <template #message-danger v-if="errorFields.includes('tope_acumulado')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col> -->
            </vs-row>
        </div>

        <template #footer>
          <div class="footer-dialog d-flex">
            <vs-button danger block @click="borrar()" style="width: 30%;">
              Cancelar
            </vs-button>
            <vs-button  success class="ml-auto" block @click="postOfertaNuevoIngresoCrear()" style="width: 30%;">
              Aceptar
            </vs-button>
          </div>

        </template>
      </vs-dialog>
    </div>
</template>
<script>
import admisiones from '../../../../../api/requests/admisiones.js'
export default {
    props:[
      'value',
      'instituciones',
      'ciclo',
      'csrf_token',
    ],
    data:() => ({
        active: false,
        institucion:'',
        institucionId: (new Date()).getTime(),
        loadingInstituto: false,
        cicloEscolar: '',
        ciclosEscolares: [],
        cicloId: (new Date()).getTime(),
        loadingCiclo: false,
        programa: '',
        programas: [],
        programaId: (new Date()).getTime(),
        loadingPrograma: false,
        periodo: '',
        periodos: [],
        periodoId: (new Date()).getTime(),
        loadingPeriodo: false,
        turno: '',
        turnos: [],
        turnoId: (new Date()).getTime(),
        loadingTurno: false,
        nombre:'',
        fecha_inicio: '',
        fecha_fin: '',
        meta: '',
        capacidad: '',
        tope_acumulado: '',
        errorFields: []
    }),
    methods:{
        borrar(){
            this.institucion = ''
            this.cicloEscolar = ''
            this.programa = ''
            this.periodo = ''
            this.turno = ''
            this.nombre = ''
            this.fecha_inicio = ''
            this.fecha_fin = ''
            this.meta = ''
            this.capacidad = ''
            this.tope_acumulado = ''
            this.active = false
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.loadingCiclo = true
                const { data: response } = await admisiones.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
                this.loadingCiclo = false
            }
        },
        async getProgramaProspecto() {
            if(this.institucion){
                this.loadingPrograma = true
                const { data: response } = await admisiones.getProgramaProspecto(this.institucion)
                this.programas = response
                this.programaId = (new Date()).getTime()
                this.loadingPrograma = false
            }
        },
        async getPeriodoOferta(){
            if(this.programa){
                this.loadingPeriodo = true
                const { data: response } = await admisiones.getPeriodoOferta(this.programa)
                this.periodos = response
                this.periodoId = (new Date()).getTime()
                this.loadingPeriodo = false
            }
        },
        async getTurnosOferta(){
            this.loadingTurno = true
            const { data: response } = await admisiones.getTurnosOferta()
            this.turnos = response
            this.turnoId = (new Date()).getTime()
            this.loadingTurno = false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.programa) {
                this.errorFields.push('programa')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.periodo) {
                this.errorFields.push('periodo')
            }
            if (!this.turno) {
                this.errorFields.push('turno')
            }
            if (!this.nombre) {
                this.errorFields.push('nombre')
            }
            if (!this.fecha_inicio) {
                this.errorFields.push('fecha_inicio')
            }
            if (!this.fecha_fin) {
                this.errorFields.push('fecha_fin')
            }
            if (!this.meta) {
                this.errorFields.push('meta')
            }
            if (!this.capacidad) {
                this.errorFields.push('capacidad')
            }
            // if (!this.tope_acumulado) {
            //     this.errorFields.push('tope_acumulado')
            // }
            if (!this.errorFields.length){
                const formData =  new FormData()
                formData.append('institucion_id', this.institucion)
                formData.append('ciclo_escolar_id', this.cicloEscolar)
                formData.append('programa_id', this.programa)
                formData.append('atributo_id', this.periodo)
                formData.append('turno_id', this.turno)
                formData.append('nombre', this.nombre)
                formData.append('fecha_inicio', this.fecha_inicio)
                formData.append('fecha_fin', this.fecha_fin)
                formData.append('meta', this.meta)
                formData.append('capacidad', this.capacidad)
                formData.append('tope_acumulado_becas', '0')
                formData.append('_token', this.csrf_token)
                return formData
            } else {
                return null
            }
        },
        async postOfertaNuevoIngresoCrear(){
            const formData = this.sanityForm()
            if(formData){
                const loading = this.$vs.loading()
                try{
                    const { data: response } = await admisiones.postOfertaNuevoIngresoCrear(formData)
                    loading.close()
                    if(response.mensaje == 'success'){
                        this.$emit('refreshTable', this.institucion, this.cicloEscolar)
                        this.borrar()
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'success',
                            position: null,
                            title: 'Operación éxitosa',
                            text: 'El registro se creo correctamente.'
                        })
                    }else{
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'No se pudo crear el registro correctamente'
                        })
                    }

                }catch{
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Algo salio mal',
                        text: 'Favor de contactar al administrador.'
                    })
                }
            }
        },
    },
    watch:{
        value (val) {
            this.active = val
        },
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        institucion(){
            this.getCicloEscolar()
            this.getProgramaProspecto()
            this.getTurnosOferta()
        },
        programa(){
            this.getPeriodoOferta()
        }
    }
}
</script>

<style>

.listAlumno{
    height: 200px;
    overflow: auto;
}
.listAlumno::-webkit-scrollbar {
    -webkit-appearance: none;
}

.listAlumno::-webkit-scrollbar:vertical {
    width:10px;
}

.listAlumno::-webkit-scrollbar-button:increment,.listAlumno::-webkit-scrollbar-button {
    display: none;
} 

.listAlumno::-webkit-scrollbar:horizontal {
    height: 10px;
}

.listAlumno::-webkit-scrollbar-thumb {
    background-color: #c0c0c0;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.listAlumno::-webkit-scrollbar-track {
    border-radius: 10px;  
}

.listAlumno .list-group-item{
    padding: 0 !important;   
    padding: 1% !important; 
}

.parentesco{
    height: 50px; 
    display: flex; 
    justify-content: center;
    align-items: center; 
    color: white;
}
</style>

<style lang="scss" scoped>

    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>